import { render, staticRenderFns } from "./stallholders.vue?vue&type=template&id=a327500a&scoped=true"
import script from "./stallholders.vue?vue&type=script&lang=js"
export * from "./stallholders.vue?vue&type=script&lang=js"
import style0 from "./stallholders.vue?vue&type=style&index=0&id=a327500a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a327500a",
  null
  
)

export default component.exports